import React, { useMemo } from 'react'
import { PREFERENCES } from '../../user/constants'

import { useUserPreferencesFetch, useUserPreference } from '../../user/hooks'
import {
  useSigEventsFetch,
  useSigEventsIncidentsFetch,
} from '../../sigevents/hooks'

import UserPanel from '../../user/components/UserPanel'
import IncidentTogglePanel from '../../sigevents/components/IncidentTogglePanel'
import SigEventsPanel from '../../sigevents/components/SigEventsPanel'

import Map from '../../map/components/Map'
import Zoom from '../../map/components/Zoom'
import BasemapToggle from '../../map/components/BasemapToggle'
import SigEventsLayer from '../../map/components/SigEventsLayer'

import TabPanel from '../../tabs/components/TabPanel'
import TabPanelContainer from '../../tabs/components/TabPanelContainer'
import MapDataToggle from '../../mobile/components/MapDataToggle'
import MobileSidebar from '../../mobile/components/MobileSidebar'
import MobileBaseLayout from '../../mobile/components/MobileBaseLayout'
import MobileSiteSwitcher from '../../mobile/components/MobileSiteSwitcher'

const tabs = [
  {
    name: 'User Options',
    icon: 'fa fa-user',
    url: '/sigEvents/userMenu',
  },
  {
    name: 'Event List',
    icon: 'fa fa-list-ul',
    url: '/sigEvents/eventList',
  },
  {
    name: 'Incident Toggle',
    icon: 'fas fa-layer-group',
    url: '/sigEvents/incidentToggle',
  },
]

const MobileLayout = () => {
  useUserPreferencesFetch() // fetch user's preferences
  useSigEventsIncidentsFetch() // fetch active sig events incidents
  useSigEventsFetch() // fetch non-deleted sig events for active incidents

  const basemap = useUserPreference(PREFERENCES.DEFAULT_BASEMAP) || 'streets-vector'

  const mapPadding = useMemo(
    () => ({
      top: 60,
      bottom: 75,
    }),
    []
  )

  return (
    <MobileBaseLayout title="Significant Events" basePath="/sigEvents">
      <MobileSidebar basePath="/sigEvents">
        <TabPanelContainer>
          <TabPanel path="/sigEvents/menu">
            <MobileSiteSwitcher tabs={tabs} />
          </TabPanel>
          <TabPanel path="/sigEvents/userMenu" component={UserPanel} />
          <TabPanel
            path="/sigEvents/incidentToggle"
            component={IncidentTogglePanel}
          />
          <TabPanel path="/sigEvents/eventList" component={SigEventsPanel} />
        </TabPanelContainer>
      </MobileSidebar>
      <MapDataToggle mapPath="/sigEvents/" listPath="/sigEvents/eventList" />
      <Map basemap={basemap} padding={mapPadding}>
        <BasemapToggle
          position="top-right"
          next={basemap === 'streets-vector' ? 'satellite' : 'streets-vector'}
        />
        <Zoom position="none" />
        <SigEventsLayer />
      </Map>
    </MobileBaseLayout>
  )
}

export default MobileLayout
